<template>
    <div>
        <v-card-actions>
            <v-container>
                <v-row>
                    <v-col cols="2">
                        <v-select
                            class="mr-3 pt-4"
                            :items="codeNameList"
                            item-value="code_key"
                            item-text="code_key_name"
                            v-model="codeKey"
                            @input="getData"
                            label="名称種別"
                        ></v-select>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-actions>
        <v-data-table
            :headers="headers"
            :items="desserts"
            hide-default-footer
            class="col-12"
            disable-pagination
            :fixed-header="true"
        >
            <template v-slot:[`item.code_name`]="{ item }">
                <v-text-field :disabled="item.codeNameDisabled" v-model="item.code_name"/>
            </template>
            <template v-slot:[`item.reserve1`]="{ item }">
                <v-text-field :disabled="item.reserve1Disabled" v-model="item.reserve1"/>
            </template>
            <template v-slot:[`item.valid_flag`]="{ item }">
                <v-checkbox :disabled="item.validFlagDisabled" v-model="item.valid_flag"/>
            </template>
        </v-data-table>
        <v-pagination
          class="my-2"
          v-model="page"
          :length="pageCount"
          :total-visible="7"
          @input="clickPagination"
        />
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                :disabled="btn[1].isActive || addBtnDisabled"
                color="green darken-4"
                text
                @click="OnAddRecord">追加</v-btn>
            <v-btn
                :disabled="btn[2].isActive || inputChange"
                color="green darken-4"
                text
                @click="OnCheckRecord">登録</v-btn>
        </v-card-actions>
        <ChangeOverlay
            page-name="名称管理"
            @processing="MakeUpdateObject"
            @cancel="changeOverlay = !changeOverlay"
            :process-result="process"
            :OverlaySwitch="changeOverlay"
        />
    </div>
</template>

<script>
import ChangeOverlay from '@/views/Master/page/overlay/ChangeOverlay';
// mixins
import { authorityMixin } from '@/views/authorityMixin';
import { golfCourseMixin } from '@/mixins/golfCourse';

import {
    GET_ALL_CODE_KEY_NAME_LIST,
    GET_CODE_MASTER_LIST,
    UPDATE_CODE_MASTER
} from '@/constants/codelist';

export default {
    components: {
        ChangeOverlay
    },
    mixins: [
        authorityMixin,
        golfCourseMixin
    ],
    data () {
        return {
            golfGroupCode: process.env.VUE_APP_GROUP_CODE,
            // 検索値
            golfCode: '',
            // セレクトボックス
            codeNameList: [],
            // v-data-tableのヘッダー
            headers: [
                { text: 'コード値', value: 'code', sortable: false },
                // { text: 'システム値', value: 'reserve2', sortable: false },
                { text: '表示値', value: 'code_name', sortable: false },
                { text: 'システム設定値', value: 'reserve1', sortable: false },
                { text: '有効フラグ', value: 'valid_flag', sortable: false }
            ],
            // v-data-table データ
            desserts: [],
            backDesserts: [],
            watchDesserts: [],
            // 削除処理結果
            process: {
                // 処理結果
                result: '',
                // 処理結果メッセージ
                resultText: '',
                // 処理中かどうか
                processing: false
            },
            // ボタンの活性・非活性
            btn: [
                { element_id: '000', element_name: '画面', isActive: true },
                { element_id: '001', element_name: '追加', isActive: true },
                { element_id: '002', element_name: '登録', isActive: true }
            ],
            // operationID
            vue_id: 'SCR0102',
            result: '',
            resultText: '',
            codeKey: '',
            maxCode: '',
            changeOverlay: false,
            // 更新確認画面
            dataUpdate: false,
            addBtnDisabled: true,
            inputChange: true,
            page: 1,
            pageCount: 0,
            begin_row: 0,
            limit_rows: 10
        };
    },
    created () {
        this.Initialize();
    },
    watch: {
        backDesserts: {
            handler (val) {
                if (JSON.stringify(this.watchDesserts) !== JSON.stringify(val)) {
                    this.inputChange = false;
                } else {
                    this.inputChange = true;
                }
            },
            deep: true
        }
    },
    methods: {
        /** ----------------------------------------------
         * 初期化処理
         * ---------------------------------------------- */
        async Initialize () {
            this.GetCodeKeyNameList();
            this.admin = await this.getLoginAdmin();
            await this.getAuthorityList();
            this.golfCourses = await this.getGolfCourseList();
        },
        /** ----------------------------------------------
         * 一覧データを取得
         * ---------------------------------------------- */
        GetCodeKeyNameList: function () {
            try {
                this.$store.commit('loading/setIsLoading', true);
                this.$apollo.query({
                    query: GET_ALL_CODE_KEY_NAME_LIST,
                    fetchPolicy: 'no-cache',
                    variables: {
                    }
                }).then(res => {
                    this.codeNameList = res.data.GetAllCodeKeyNameList.CodeKeyNameList;
                    this.codeKey = this.codeNameList[0].code_key;
                    this.getData();
                });
                this.$store.commit('loading/setIsLoading', false);
            } catch (error) {
                this.resultText = error;
                this.$store.commit('loading/setIsLoading', false);
            }
        },
        /** ----------------------------------------------
         * 一覧データを取得
         * ---------------------------------------------- */
        getData () {
            try {
                this.$store.commit('loading/setIsLoading', true);
                this.$apollo.query({
                    query: GET_CODE_MASTER_LIST,
                    fetchPolicy: 'no-cache',
                    variables: {
                        code_key: this.codeKey
                    }
                }).then(res => {
                    var desserts = res.data.GetCodeMasterList.CodeList;
                    this.backDesserts = [];
                    this.desserts = [];
                    var codeList = [];
                    // valid_flagをBooleanに変換する
                    for (var i = 0; i < desserts.length; i++) {
                        codeList.push(Number(desserts[i].code));
                        this.backDesserts.push(
                            {
                                code_key: desserts[i].code_key,
                                code: desserts[i].code,
                                code_name: desserts[i].code_name,
                                code_key_name: desserts[0].code_key_name,
                                reserve1: desserts[i].reserve1,
                                reserve2: desserts[i].reserve2,
                                reserve3: desserts[i].reserve3,
                                reserve4: desserts[i].reserve4,
                                reserve5: desserts[i].reserve5,
                                valid_flag: Boolean(desserts[i].valid_flag),
                                codeNameDisabled: true,
                                reserve1Disabled: true,
                                validFlagDisabled: true
                            }
                        );
                        this.backDesserts[i].valid_flag = Boolean(this.backDesserts[i].valid_flag);
                        // 0は編集不可
                        if (this.backDesserts[i].reserve2 === '0') {
                            this.backDesserts[i].codeNameDisabled = true;
                            this.backDesserts[i].reserve1Disabled = true;
                            this.addBtnDisabled = true;
                            this.inputChange = true;
                        // 1は表示値(code_name)のみ編集可
                        } else if (this.backDesserts[i].reserve2 === '1') {
                            this.backDesserts[i].codeNameDisabled = false;
                            this.backDesserts[i].reserve1Disabled = true;
                            this.addBtnDisabled = true;
                        // 2はシステム設定値も編集可
                        } else if (this.backDesserts[i].reserve2 === '2') {
                            this.backDesserts[i].codeNameDisabled = false;
                            this.backDesserts[i].reserve1Disabled = false;
                            this.addBtnDisabled = true;
                        // 3は追加可能で表示値のみ編集可
                        } else if (this.backDesserts[i].reserve2 === '3') {
                            this.backDesserts[i].codeNameDisabled = false;
                            this.backDesserts[i].reserve1Disabled = true;
                            this.addBtnDisabled = false;
                        // 4は追加可能で表示値、システム設定値も編集可
                        } else if (this.backDesserts[i].reserve2 === '4') {
                            this.backDesserts[i].codeNameDisabled = false;
                            this.backDesserts[i].reserve1Disabled = false;
                            this.addBtnDisabled = false;
                        }

                        // 1は削除可
                        if (this.backDesserts[i].reserve3 === '1') {
                            this.backDesserts[i].validFlagDisabled = false;
                        }
                    }
                    // コードの最大値を取っておく
                    this.maxCode = Math.max.apply(null, codeList);
                    this.page = 1;
                    this.pageCount = Math.ceil(desserts.length / 10);
                    this.begin_row = 0;
                    this.limit_rows = 10;
                    this.desserts = this.backDesserts.slice(this.begin_row, (this.begin_row + this.limit_rows));
                    // watch監視用に
                    this.watchDesserts = JSON.parse(JSON.stringify(this.backDesserts));
                });
                this.$store.commit('loading/setIsLoading', false);
            } catch (error) {
                this.resultText = error;
                this.$store.commit('loading/setIsLoading', false);
            }
        },
        /** --------------------------------------------
        * 更新用オブジェクト作成
        * -------------------------------------------- */
        MakeUpdateObject: function () {
            var obj = [];
            for (let el of this.backDesserts) {
                obj.push(
                    {
                        code_key: el.code_key,
                        code: el.code,
                        code_name: el.code_name,
                        code_key_name: el.code_key_name,
                        reserve1: el.reserve1,
                        reserve2: el.reserve2,
                        reserve3: el.reserve3,
                        reserve4: el.reserve4,
                        reserve5: el.reserve5,
                        valid_flag: Number(el.valid_flag)
                    }
                );
            }
            this.UpdateCodeMaster(obj);
        },
        /** --------------------------------------------
        * コードマスタ更新
        * @param {object} obj MakeUpdateObjectで作成された更新オブジェクト
        * -------------------------------------------- */
        UpdateCodeMaster: function (obj) {
            let me = this;
            this.$apollo.mutate({
                mutation: UPDATE_CODE_MASTER,
                variables: {
                    ChangeCodeKeyList: obj
                }
            }).then(res => {
                me.process.result = '1';
                me.process.resultText = this.$t('result.success.change');
                this.getData();
            }).catch(err => {
                me.process.result = '1';
                me.process.resultText = this.$t('result.error.change');
                me.changeOverlay = true;
                me.processing = false;
                this.error = err;
            });
        },
        /** ----------------------------------------------
         * レコード追加
         * ---------------------------------------------- */
        OnAddRecord () {
            this.maxCode++;
            this.backDesserts.push(
                {
                    code_key: this.backDesserts[0].code_key,
                    code: this.maxCode,
                    code_name: '',
                    code_key_name: this.backDesserts[0].code_key_name,
                    reserve1: '',
                    reserve2: this.backDesserts[0].reserve2,
                    reserve3: this.backDesserts[0].reserve3,
                    reserve4: this.backDesserts[0].reserve4,
                    reserve5: this.backDesserts[0].reserve5,
                    valid_flag: true,
                    codeNameDisabled: this.backDesserts[0].codeNameDisabled,
                    reserve1Disabled: this.backDesserts[0].reserve1Disabled,
                    validFlagDisabled: this.backDesserts[0].validFlagDisabled
                }
            );
            this.desserts = this.backDesserts.slice(this.begin_row, (this.begin_row + this.limit_rows));
            this.pageCount = Math.ceil(this.backDesserts.length / 10);
        },
        /** ----------------------------------------------
         * レコードチェック
         * ---------------------------------------------- */
        OnCheckRecord () {
            this.process.result = '';
            this.resultText = '';
            for (let el of this.backDesserts) {
                // 表示値になにもなければエラー
                if (!el.code_name.trim()) {
                    this.process.result = '1';
                    this.process.resultText = '表示値を入力してください。';
                    this.changeOverlay = true;
                    // this.resultText = '設定値を入力してください。';
                    return;
                }
            }
            this.changeOverlay = true;
        },
        /** --------------------------------------------
        * ページネーション
        * -------------------------------------------- */
        clickPagination: function () {
            this.begin_row = this.page * this.limit_rows - this.limit_rows;
            this.desserts = [];
            this.desserts = this.backDesserts.slice(this.begin_row, (this.begin_row + this.limit_rows));
        }
    }
};
</script>

<style scoped>
    .v-data-table{
        overflow-y: scroll;
        min-height: 200px;
        max-height: 600px;
    }
    .alert{
        color: red;
    }
</style>
